import React from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export interface RowExpansionControlsProps {
	expandedCount: number;
	totalExpandable: number;
	disabled?: boolean;
	onToggle(): void;
}

// Hidden below `xl`: mobile/tablet cards already show every field, so the
// row-expansion toggle (which only affects the `xl` grid's truncated cells) is redundant.
const buttonClass =
	'hidden xl:flex items-center gap-1.5 h-8 px-3 rounded border border-cPurple-400 bg-white text-sm font-semibold text-cPurple-600 shadow-sm tracking-wide transition-colors hover:bg-cPurple-600 hover:border-cPurple-600 hover:text-white disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-cPurple-400 disabled:hover:text-cPurple-600';

export function RowExpansionControls({
	expandedCount,
	totalExpandable,
	disabled,
	onToggle,
}: RowExpansionControlsProps) {
	const allExpanded = totalExpandable > 0 && expandedCount >= totalExpandable;

	return (
		<button type='button' className={buttonClass} disabled={disabled} onClick={onToggle}>
			{allExpanded ? 'Sbalit vše' : 'Rozbalit vše'}
			{allExpanded ? (
				<FaChevronUp className='w-3 h-3 flex-shrink-0' aria-hidden='true' />
			) : (
				<FaChevronDown className='w-3 h-3 flex-shrink-0' aria-hidden='true' />
			)}
		</button>
	);
}
